import React from 'react';

const DEVELOPER_TELEGRAM_URL = 'https://t.me/rahmin44';

export const DeveloperCredit: React.FC = () => {
  const handleClick = () => {
    try {
      const openTelegramLink = window.Telegram?.WebApp?.openTelegramLink;

      if (openTelegramLink) {
        openTelegramLink(DEVELOPER_TELEGRAM_URL);
        return;
      }
    } catch (error) {
      console.warn('[DeveloperCredit] Telegram link open failed:', error);
    }

    window.open(DEVELOPER_TELEGRAM_URL, '_blank');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="mx-auto flex w-fit items-center justify-center px-2 py-1 text-[11px] font-medium text-white/35 transition-colors hover:text-white/60 focus:outline-none focus:ring-2 focus:ring-amber-400/20 active:scale-[0.98]"
      aria-label="Открыть Telegram-профиль разработчика @rahmin44"
    >
      Разработчик: @rahmin44
    </button>
  );
};
